/* eslint-disable */
export default {
  cancel: '취소',
  confirm: '확인',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
